import { useQuery, UseQueryResult } from 'react-query';
import { videoSitemapGqlQuery } from 'src/modules/videos/graphql/videos-sitemap.query';
import { QueryKey } from 'src/models/query';
import { VideoEntityBasic } from 'src/models/directus';
import { fetchPublicDirectusGqlItems } from 'src/services/directus/common';

export const fetchSitemapVideos = () =>
  fetchPublicDirectusGqlItems(videoSitemapGqlQuery).then((a) =>
    a.videos.filter((v) => v),
  );

export const useVideosSitemapQuery = (): UseQueryResult<
  VideoEntityBasic | undefined
> => {
  return useQuery(QueryKey.VideoSitemap, fetchSitemapVideos);
};
